<div class="lib">

  <!-- ── Header ───────────────────────────────────────────────── -->
  <header class="lib__header">
    <div>
      <h1 class="lib__title">
        <i class="fa-solid fa-book-open lib__title-icon"></i>
        {{ 'LIBRARY.TITLE' | translate }}
      </h1>
      <p class="lib__subtitle">{{ 'LIBRARY.SUBTITLE' | translate }}</p>
    </div>
    <span class="lib__count">
      {{ 'LIBRARY.COUNT' | translate:{ count: filtered().length } }}
    </span>
  </header>

  <!-- ── Filters bar ──────────────────────────────────────────── -->
  <section class="lib__filters" aria-label="Filters">
    <!-- Search -->
    <div class="lib__search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="search"
             [value]="query()"
             (input)="onQueryInput($any($event.target).value)"
             [placeholder]="'LIBRARY.SEARCH_PLACEHOLDER' | translate"
             aria-label="Search">
    </div>

    <!-- Subject -->
    <div class="lib__select" *ngIf="availableSubjects().length > 0">
      <i class="fa-solid fa-book"></i>
      <select [value]="selectedSubject()"
              (change)="setSubject($any($event.target).value)">
        <option value="ALL">{{ 'LIBRARY.FILTER_BY_SUBJECT' | translate }}</option>
        <option *ngFor="let s of availableSubjects()" [value]="s">{{ s }}</option>
      </select>
      <i class="fa-solid fa-chevron-down lib__select-chevron"></i>
    </div>
  </section>

  <!-- Category chips -->
  <nav class="lib__chips" aria-label="Category filter">
    <button *ngFor="let f of categoryFilters"
            class="lib__chip"
            type="button"
            [class.is-active]="selectedCategory() === f.key"
            (click)="setCategory(f.key)">
      <i [class]="f.icon"></i>
      {{ f.i18nKey | translate }}
    </button>

    <button class="lib__chip lib__chip--fav"
            type="button"
            [class.is-active]="showFavoritesOnly()"
            (click)="toggleFavorites()">
      <i [class]="showFavoritesOnly() ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"></i>
      {{ 'LIBRARY.FILTER_FAVORITES' | translate }}
    </button>
  </nav>

  <!-- ── Loading skeleton ─────────────────────────────────────── -->
  <div *ngIf="loading()" class="lib__skeleton">
    <div class="lib__skel-row" *ngFor="let _ of [1,2,3]"></div>
  </div>

  <!-- ── Results ──────────────────────────────────────────────── -->
  <ng-container *ngIf="!loading()">

    <!-- Erreur de chargement : jamais de données de substitution -->
    <app-error-state *ngIf="errored()"
                     titleKey="LIBRARY.ERROR_TITLE"
                     messageKey="LIBRARY.ERROR_DESC"
                     (retry)="reload()"></app-error-state>

    <ng-container *ngIf="!errored()">
      <div class="lib__list" *ngIf="filtered().length > 0; else emptyTpl">
        <app-course-material-card
          *ngFor="let m of filtered()"
          [material]="m"
          [showFavorite]="true"
          [isFavorite]="!!m.isFavorite"
          (favoriteToggled)="onFavoriteToggle(m, $event)"
          (download)="onDownload($event)"
          (preview)="previewTarget.set($event)"
          (openExternal)="onOpenExternal($event)">
        </app-course-material-card>
      </div>

      <!-- ── Empty state ───────────────────────────────────────── -->
      <ng-template #emptyTpl>
        <div class="lib__empty">
          <div class="lib__empty-icon">
            <i class="fa-solid fa-folder-open"></i>
          </div>
          <ng-container *ngIf="materials().length === 0">
            <h3>{{ 'LIBRARY.EMPTY_TITLE' | translate }}</h3>
            <p>{{ 'LIBRARY.EMPTY_DESC' | translate }}</p>
          </ng-container>
          <ng-container *ngIf="materials().length > 0">
            <h3>{{ 'LIBRARY.EMPTY_FILTER_TITLE' | translate }}</h3>
            <p>{{ 'LIBRARY.EMPTY_FILTER_DESC' | translate }}</p>
            <button class="lib__reset" type="button" (click)="resetFilters()">
              <i class="fa-solid fa-rotate-left"></i>
              {{ 'LIBRARY.FILTER_ALL' | translate }}
            </button>
          </ng-container>
        </div>
      </ng-template>
    </ng-container>

  </ng-container>

</div>

<!-- Aperçu : le flux passe par l'endpoint élève, qui exige le jeton. -->
<app-material-preview
  [material]="previewTarget()"
  [download]="downloadFn"
  (closed)="previewTarget.set(null)"></app-material-preview>
